import { render } from "./index.vue?vue&type=template&id=21f57425"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=21f57425&lang=scss"

import exportComponent from "C:\\www\\momentum_v2\\momentum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__